export default __webpack_public_path__ + "static/media/art-center.087dd750.jpg";